// household.js — labels for the people and pets in a user's home.
//
// Morning Mode used to hardcode one household: "Mackenzie's medication",
// "Mackenzie can eat 🐾", "Take your SPLIT". Those read as a bug to anyone else.
//
// The rule throughout: when a household detail is absent, HIDE the step rather
// than substituting a generic label. A checklist item reading "Pet's
// medication" for someone with no pet is worse than no item at all — it implies
// they forgot to configure something, when in fact it does not apply.

const EMPTY = { display_name: "", pets: [], self_meds_label: "" };

export function household(preferences) {
  const h = preferences?.household || {};
  return {
    display_name: h.display_name || "",
    pets: Array.isArray(h.pets) ? h.pets.filter(p => p?.name) : [],
    self_meds_label: h.self_meds_label || "",
  };
}

/** The pet whose meds the morning routine tracks — the first one configured. */
export function medsPet(preferences) {
  return household(preferences).pets[0] || null;
}

/** "Mackenzie's medication", or null when no pet is configured. */
export function petMedsLabel(preferences) {
  const pet = medsPet(preferences);
  if (!pet) return null;
  return `${pet.name}'s ${pet.meds_label || "medication"}`;
}

/** "Mackenzie can eat 🐾" — the post-timer all-clear. Null when no pet. */
export function petClearLabel(preferences) {
  const pet = medsPet(preferences);
  if (!pet) return null;
  return `${pet.name} can eat${pet.emoji ? ` ${pet.emoji}` : ""}`;
}

/** "Take your SPLIT", or null when the user tracks no medication. */
export function selfMedsLabel(preferences) {
  const label = household(preferences).self_meds_label;
  return label ? `Take your ${label}` : null;
}

/**
 * How the AI should refer to the user. Falls back to "the user" rather than a
 * name, so prompts read naturally for someone who has not set one.
 */
export function userName(preferences) {
  return household(preferences).display_name || "the user";
}

export const EMPTY_HOUSEHOLD = EMPTY;
